module.exports = __webpack_public_path__ + "media/site_templates/www.hirecarpenters.com.au/images/testimonials-c46ec520386bcc515dbc3f4c09882569.jpg";